$shm_hitalama_process_monitor_branch $mol_expander
	render_visible_only false
	Label $mol_view
		sub /
			<= Tools null
	Trigger $mol_check_expand
		checked? <=> expanded? false
		expandable <= expandable true
		label /
			<= Caption $mol_view
				sub / <= caption \
	Content $mol_list
		rows <= content /
		render_visible_only false
		sub_visible <= content /
